import script from "./DealerCombinedAchievementGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./DealerCombinedAchievementGoals.vue?vue&type=script&setup=true&lang=js"

import "./DealerCombinedAchievementGoals.vue?vue&type=style&index=0&id=019a55cc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019a55cc"]])

export default __exports__